/**
 * OZK 비즈니스 페이지
 */

import Seo from "@/components/seo/Seo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, TrendingUp, Users } from "lucide-react";
import { Link } from "wouter";

export default function Business() {
  return (
    <>
      <Seo
        title="OZK 비즈니스 — OZK News"
        description="OZK News 비즈니스 솔루션을 확인하세요."
        path="/business"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">OZK 비즈니스</h1>
            <p className="text-lg text-muted-foreground">
              비즈니스 성장을 위한 다양한 솔루션
            </p>
          </div>

          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Building2 className="w-5 h-5" />
                  비즈니스 디렉토리
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">
                  호주 한인 커뮤니티에 비즈니스를 홍보하고 고객을 만나보세요.
                </p>
                <Link href="/business-directory">
                  <span className="text-brand-primary hover:underline cursor-pointer">
                    비즈니스 디렉토리 보기 →
                  </span>
                </Link>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <TrendingUp className="w-5 h-5" />
                  광고 서비스
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">
                  타겟 고객에게 효과적으로 도달하는 광고 솔루션을 제공합니다.
                </p>
                <Link href="/advertise">
                  <span className="text-brand-primary hover:underline cursor-pointer">
                    광고 문의하기 →
                  </span>
                </Link>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Users className="w-5 h-5" />
                  제휴 문의
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground mb-4">
                  다양한 제휴 기회를 통해 함께 성장할 수 있습니다.
                </p>
                <Link href="/partnership">
                  <span className="text-brand-primary hover:underline cursor-pointer">
                    제휴 문의하기 →
                  </span>
                </Link>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
